// src/store/formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

// Interface for CorporationForm data (Step 1)
interface CorporationFormData {
  typeOfCompany: string;
  cin: string;
  organisationName: string;
  email: string;
  Mailotp: string;
  mobile: string;
  gst: string;
  pan: string;
  dateOfInc: string | null;
  registerAdd: string;
  pinCode: string;
  stateName: string;
  districtName: string;
  companyweb: string;
  panCardBase64: any | null;
  gstCertificateBase64: any | null;
  csrCertiBase64: any | null;
}
interface ContactPersonFormData {
  contactPerson: string;
  designation: string;
  mobile: string;
  email: string;
}

interface FinancialYearData {
    id: any;
    financial_year: string;
    turnover?: string;
    profit_loss?: string;
    csr_spent?: string;
    fy_statement_file?: any | null;
}
interface BanksData {
  id?: number;
  name: string;
  account: string;
  ifsc: string;
  cheque?: any | null;
  username?: string;
  isDefault?: boolean
}

// Combined state interface
interface FormState {
  corporation: CorporationFormData;
  contactPerson: ContactPersonFormData;
  financialData: FinancialYearData[];
  banksData: BanksData[];
}

const initialState: FormState = {
  corporation: {
    typeOfCompany: '',
    cin: '',
    organisationName: '',
    email: '',
    Mailotp: '',
    mobile: '',
    gst: '',
    pan: '',
    dateOfInc: dayjs().format('YYYY-MM-DD'),
    registerAdd: '',
    pinCode: '',
    stateName: '',
    districtName: '',
    companyweb: '',
    panCardBase64: null,
    gstCertificateBase64: null,
    csrCertiBase64: null,
  },
  contactPerson: {
    contactPerson: '',
    designation: '',
    mobile: '',
    email: '',
  },
  financialData: [{ financial_year: '', turnover: '', profit_loss: '', csr_spent: '', fy_statement_file: null,id:null }],
  banksData: [{ name: '', account: '', ifsc: '', cheque: null, username: '' ,isDefault: false}],
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateCorporationForm: (state, action: PayloadAction<Partial<CorporationFormData>>) => {
      state.corporation = { ...state.corporation, ...action.payload };
    },
    updateContactPersonForm: (state, action: PayloadAction<Partial<ContactPersonFormData>>) => {
      state.contactPerson = { ...state.contactPerson, ...action.payload };
    },
    updateFinancialData: (state, action: PayloadAction<FinancialYearData[]>) => {
        state.financialData = action.payload;
    },
    updateBankData: (state, action: PayloadAction<BanksData[]>) => {
        state.banksData = action.payload;
    },
    clearFormData: () => initialState,
  },
});

export const { updateCorporationForm, updateContactPersonForm, clearFormData,updateFinancialData ,updateBankData} = formSlice.actions;
export default formSlice.reducer;